(ns quuppa.qpe.pe.universalformat.universal-target
  (:require [clojure.set :as set]
            [malli.core :as m]
            ;; FIXME: common dependency.. good or bad? :D
            [quuppa.common.qpe.pe.universalformat.schema :as schema]
            [quuppa.common.malli.transform :as tf]))


#?(:cljs
   (defn decode-control-params [controlled-ut]
     (m/decode schema/control-universal-target-schema controlled-ut tf/strip-extra-keys)))


#?(:cljs
   (defn make-universal-target
     "Encode backend values to universal-target API schema, with :ui/default applied.
     Does not validate the result! You could use `m/coerce` or `m/explain` to check validity."
     [backend-ut]
     (let [ut (set/rename-keys backend-ut {:formatId :format
                                           :ip       :ipAddress})]
       (m/encode schema/create-universal-target-schema ut tf/ui-defaults-transformer))))
